import { render, staticRenderFns } from "./network-resource-item-5-network-privileges-settings.vue?vue&type=template&id=dff5e524&scoped=true&"
import script from "./network-resource-item-5-network-privileges-settings.vue?vue&type=script&lang=ts&"
export * from "./network-resource-item-5-network-privileges-settings.vue?vue&type=script&lang=ts&"
import style0 from "./network-resource-item-5-network-privileges-settings.vue?vue&type=style&index=0&id=dff5e524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff5e524",
  null
  
)

export default component.exports